const fieldConfig = {
    // 全电普票
    1: {
        version: 1.13,
        queryForm: [
            {
                label: '单据编号',
                selected: true,
                default: true,
            },
            {
                label: '购方名称/信用代码',
                selected: true,
                default: true,
            },
            {
                label: '发票种类',
                selected: true,
                default: true,
            },
            {
                // 3
                label: '审核状态',
                selected: false,
                default: false,
            },
            {
                label: '发票性质',
                selected: false,
                default: false,
            },
            {
                // 5
                label: '处理状态',
                selected: false,
                default: false,
            },
            {
                label: '申请方',
                selected: false,
                default: false,
            },
            {
                label: '申请日期',
                selected: true,
                default: true,
            },
            {
                label: '主商品名称',
                selected: false,
                default: false,
            },
            {
                label: '单据日期',
                selected: false,
                default: false,
            },
            {
                label: '税率',
                selected: false,
                default: false,
            },
            {
                label: '扩展1',
                selected: false,
                default: false,
            },
            {
                label: '扩展2',
                selected: false,
                default: false,
            },
            {
                label: '扩展3',
                selected: false,
                default: false,
            },
            {
                label: '特定业务类型',
                selected: false,
                default: false,
            },
        ],
        table: [
            {
                label: '单据编号',
                selected: true,
                default: true,
            },
            {
                label: '发票种类',
                selected: true,
                default: true,
            },
            {
                label: '购方名称',
                selected: true,
                default: true,
            },
            {
                label: '购方信用代码',
                selected: true,
                default: true,
            },
            {
                label: '购方地址电话',
                selected: false,
                default: false,
            },
            {
                label: '购方开户行及账号',
                selected: false,
                default: false,
            },
            {
                label: '合计金额',
                selected: true,
                default: true,
            },
            {
                label: '合计税额',
                selected: true,
                default: true,
            },
            {
                label: '处理状态',
                selected: true,
                default: true,
            },
            {
                label: '审核状态', //9
                selected: false,
                default: false,
            },
            {
                label: '申请日期',
                selected: true,
                default: true,
            },
            {
                label: '价税合计',
                selected: false,
                default: false,
            },
            {
                label: '含税折扣金额',
                selected: false,
                default: false,
            },
            {
                label: '备注',
                selected: false,
                default: false,
            },
            {
                label: '主商品名称',
                selected: false,
                default: false,
            },
            {
                label: '申请方',
                selected: false,
                default: false,
            },
            {
                label: '单据日期',
                selected: false,
                default: false,
            },
            {
                // 14
                label: '税率',
                selected: false,
                default: false,
            },
            {
                label: '销方开户行及账号',
                selected: false,
                default: false,
            },
            {
                label: '扩展1',
                selected: false,
                default: false,
            },
            {
                label: '扩展2',
                selected: false,
                default: false,
            },
            {
                label: '扩展3',
                selected: false,
                default: false,
            },
            {
                label: '特定业务类型',
                selected: false,
                default: false,
            },
        ],
    },
    // 全电专票
    2: {
        version: 1.11,
        queryForm: [
            {
                label: '单据编号',
                selected: true,
                default: true,
            },
            {
                label: '购方名称/信用代码',
                selected: true,
                default: true,
            },
            {
                label: '发票种类',
                selected: true,
                default: true,
            },
            {
                // 3
                label: '审核状态',
                selected: false,
                default: false,
            },
            {
                label: '发票性质',
                selected: false,
                default: false,
            },
            {
                // 5
                label: '处理状态',
                selected: false,
                default: false,
            },
            {
                label: '申请方',
                selected: false,
                default: false,
            },
            {
                label: '申请日期',
                selected: true,
                default: true,
            },
            {
                label: '主商品名称',
                selected: false,
                default: false,
            },
            {
                label: '单据日期',
                selected: false,
                default: false,
            },
            {
                label: '税率',
                selected: false,
                default: false,
            },
            {
                label: '扩展1',
                selected: false,
                default: false,
            },
            {
                label: '扩展2',
                selected: false,
                default: false,
            },
            {
                label: '扩展3',
                selected: false,
                default: false,
            },
            {
                label: '特定业务类型',
                selected: false,
                default: false,
            },
        ],
        table: [
            {
                label: '单据编号',
                selected: true,
                default: true,
            },
            {
                label: '发票种类',
                selected: true,
                default: true,
            },
            {
                label: '购方名称',
                selected: true,
                default: true,
            },
            {
                label: '购方信用代码',
                selected: true,
                default: true,
            },
            {
                label: '购方地址电话',
                selected: false,
                default: false,
            },
            {
                label: '购方开户行及账号',
                selected: false,
                default: false,
            },
            {
                label: '合计金额',
                selected: true,
                default: true,
            },
            {
                label: '合计税额',
                selected: true,
                default: true,
            },
            {
                label: '处理状态',
                selected: true,
                default: true,
            },
            {
                label: '审核状态', //9
                selected: false,
                default: false,
            },
            {
                label: '申请日期',
                selected: true,
                default: true,
            },
            {
                label: '价税合计',
                selected: false,
                default: false,
            },
            {
                label: '含税折扣金额',
                selected: false,
                default: false,
            },
            {
                label: '备注',
                selected: false,
                default: false,
            },
            {
                label: '主商品名称',
                selected: false,
                default: false,
            },
            {
                label: '申请方',
                selected: false,
                default: false,
            },
            {
                label: '单据日期',
                selected: false,
                default: false,
            },
            {
                // 14
                label: '税率',
                selected: false,
                default: false,
            },
            {
                label: '销方开户行及账号',
                selected: false,
                default: false,
            },
            {
                label: '扩展1',
                selected: false,
                default: false,
            },
            {
                label: '扩展2',
                selected: false,
                default: false,
            },
            {
                label: '扩展3',
                selected: false,
                default: false,
            },
            {
                label: '特定业务类型',
                selected: false,
                default: false,
            },
        ],
    },
    3: {
        version: 1.6,
        queryForm: [
            {
                label: '单据编号',
                selected: true,
                default: true,
            },
            {
                label: '购方名称/信用代码',
                selected: true,
                default: true,
            },
            {
                label: '发票种类',
                selected: true,
                default: true,
            },
            {
                label: '发票性质',
                selected: false,
                default: false,
            },
            {
                // 5
                label: '处理状态',
                selected: false,
                default: false,
            },
            {
                label: '申请方',
                selected: false,
                default: false,
            },
            {
                label: '申请日期',
                selected: true,
                default: true,
            },
            {
                label: '主商品名称',
                selected: false,
                default: false,
            },
            {
                label: '单据日期',
                selected: false,
                default: false,
            },
            {
                label: '税率',
                selected: false,
                default: false,
            },
            {
                label: '扩展1',
                selected: false,
                default: false,
            },
            {
                label: '扩展2',
                selected: false,
                default: false,
            },
            {
                label: '扩展3',
                selected: false,
                default: false,
            },
            {
                // 14
                label: '发票代码',
                selected: true,
                default: true,
            },
            {// 15
                label: '发票号码',
                selected: true,
                default: true,
            },
            {
                label: '特定业务类型',
                selected: false,
                default: false,
            },
        ],
        table: [
            {
                label: '单据编号',
                selected: true,
                default: true,
            },
            {
                label: '发票种类',
                selected: true,
                default: true,
            },
            {
                label: '购方名称',
                selected: true,
                default: true,
            },
            {
                label: '购方信用代码',
                selected: true,
                default: true,
            },
            {
                label: '购方地址电话',
                selected: false,
                default: false,
            },
            {
                label: '购方开户行及账号',
                selected: false,
                default: false,
            },
            {
                label: '合计金额',
                selected: true,
                default: true,
            },
            {
                label: '合计税额',
                selected: true,
                default: true,
            },
            {
                label: '处理状态',
                selected: true,
                default: true,
            },
            {
                label: '申请日期',
                selected: true,
                default: true,
            },
            {
                label: '价税合计',
                selected: false,
                default: false,
            },
            {
                label: '含税折扣金额',
                selected: false,
                default: false,
            },
            {
                label: '备注',
                selected: false,
                default: false,
            },
            {
                label: '主商品名称',
                selected: false,
                default: false,
            },
            {
                label: '申请方',
                selected: false,
                default: false,
            },
            {
                label: '单据日期',
                selected: false,
                default: false,
            },
            {
                // 14
                label: '税率',
                selected: false,
                default: false,
            },
            {
                label: '销方开户行及账号',
                selected: false,
                default: false,
            },
            {
                label: '扩展1',
                selected: false,
                default: false,
            },
            {
                label: '扩展2',
                selected: false,
                default: false,
            },
            {
                label: '扩展3',
                selected: false,
                default: false,
            },
            {
                label: '关联发票',
                selected: false,
                default: false,
            },
            {
                label: '发票代码',
                selected: false,
                default: false,
            },
            {
                label: '发票号码',
                selected: false,
                default: false,
            },
            {
                label: '特定业务类型',
                selected: false,
                default: false,
            },
        ],
    },
}
export default fieldConfig



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/fieldConfig.js